/**
 * Central logo registry (folder-based, file-agnostic).
 * ─────────────────────────────────────────────────────────────────────────────
 * Each logo is addressed by its ROLE (the sub-folder name), not by file name.
 * Drop a single image file into the matching folder and it is picked up
 * automatically — so the underlying artwork can change in future without any
 * code change. Only the folder layout is a contract:
 *
 *   src/assets/images/logos/
 *     FullRectangleLogo/  → full rectangular D-hive.ai logo (loading + pairing screens)
 *
 * Keep exactly one image file per folder. If a folder holds several, the first
 * (alphabetical) is used.
 */

// Eagerly import every image in every logo sub-folder. Vite resolves these to
// hashed URLs at build time.
const modules = import.meta.glob("./*/*.{png,jpg,jpeg,svg,webp,gif,ico}", {
  eager: true,
  query: "?url",
  import: "default",
});

// Group resolved URLs by their role (immediate sub-folder name).
const byRole = {};
for (const [path, url] of Object.entries(modules)) {
  // path looks like "./FullRectangleLogo/dhive logo.png"
  const match = path.match(/^\.\/([^/]+)\//);
  if (!match) continue;
  const role = match[1];
  (byRole[role] ||= []).push({ path, url });
}

const resolveRole = (role) => {
  const entries = byRole[role];
  if (!entries || entries.length === 0) return null;
  // Deterministic pick when a folder happens to contain more than one file.
  entries.sort((a, b) => a.path.localeCompare(b.path));
  return entries[0].url;
};

export const FullRectangleLogo = resolveRole("FullRectangleLogo");

const logos = { FullRectangleLogo };
export default logos;
